import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';
import moment from 'moment';

import { ButtonGroup, DropdownButton, MenuItem, Button } from 'components/graylog';
import { Pluralize, Icon } from 'components/common';

import StoreProvider from 'injection/StoreProvider';

import ActionsProvider from 'injection/ActionsProvider';

const RefreshStore = StoreProvider.getStore('Refresh');
const RefreshActions = ActionsProvider.getActions('Refresh');

const RefreshControls = createReactClass({
  displayName: 'RefreshControls',
  mixins: [Reflux.connect(RefreshStore, 'refresh')],

  INTERVAL_OPTIONS: {
    '1 Second': 1,
    '2 Seconds': 2,
    '5 Seconds': 5,
    '10 Seconds': 10,
    '30 Seconds': 30,
    '1 Minute': 60,
    '5 Minutes': 300,
  },

  _changeInterval(interval) {
    RefreshActions.changeInterval(interval);
    RefreshActions.enable();
  },

  render() {
    const intervalOptions = Object.keys(this.INTERVAL_OPTIONS).map((key) => {
      const interval = this.INTERVAL_OPTIONS[key] * 1000;
      return <MenuItem key={`RefreshControls-${key}`} onClick={() => this._changeInterval(interval)}>{key}</MenuItem>;
    });
    const intervalDuration = moment.duration(this.state.refresh.interval);
    const naturalInterval = intervalDuration.asSeconds() < 60
      ? <span>{intervalDuration.asSeconds()} <Pluralize singular="second" plural="seconds" value={intervalDuration.asSeconds()} /></span>
      : <span>{intervalDuration.asMinutes()} <Pluralize singular="minute" plural="minutes" value={intervalDuration.asMinutes()} /></span>;
    const buttonLabel = <span>Update every {naturalInterval}</span>;
    return (
      <ButtonGroup>
        <Button bsSize="small" onClick={() => (this.state.refresh.enabled ? RefreshActions.disable() : RefreshActions.enable())}>
          <Icon name={this.state.refresh.enabled ? 'pause' : 'play'} />
        </Button>

        <DropdownButton bsSize="small" title={this.state.refresh.enabled ? buttonLabel : 'Not updating'} id="refresh-options-dropdown">
          {intervalOptions}
        </DropdownButton>
      </ButtonGroup>
    );
  },
});

export default RefreshControls;
